import { moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { PosService } from "src/app/_services/posService";
import { InvoiceService } from "./../../../_services/invoice.service";

@Component({
  selector: "app-upload-preview",
  templateUrl: "./upload-preview.component.html",
  styleUrls: ["./upload-preview.component.scss"],
})
export class UploadPreviewComponent implements OnInit, DirtyCheckComponent {
  invoiceDetails: any;
  invoiceType: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  invoiceSaved: boolean = false;
  uploadInvoice: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  displayName: any;
  hasError = false;
  pdfSrc: any;
  fileSizeError = false;
  fileTypeError = false;
  totalSizeError = false;
  typeError = false;
  sizeError = false;
  supportingDocuments: any[] = [];
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  responseData: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  poNo: any;
  eInvoice = false;
  servItems: any;
  eLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  files: File[];
  canSubmitForm = false;
  allDeleted = false;
  supportingDocsAdded = false;
  error: any;
  serverError = false;
  savingError = false;

  extractedInvoice = new FormGroup({
    invoiceType: new FormControl("e-invoice"),
    file: new FormControl(null),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
  });

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private posService: PosService,
    private authService: AuthService,
    private dateUtils: DateUtilsService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  selectDocuments(event: any) {
    const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
    const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 100MB
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    // Calculate the total size of the selected files (in bytes)
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    // Check if the total size exceeds 25 MB
    if (totalSize > MAX_TOTAL_SIZE) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
    }

    for (const file of this.files) {
      // Check if any individual file size exceeds 5 MB
      if (file.size > MAX_FILE_SIZE) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not Word, Excel, or PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }


    if (this.allDeleted === true) {
      if (this.extractedInvoice.get("terms_agreed").value === true) {
        this.extractedInvoice.patchValue({ terms_agreed: false });
      }
    } else {
      this.extractedInvoice.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);

    if (this.supportingDocuments.length === 0) {
      if (this.extractedInvoice.get("terms_agreed").value === true) {
        this.extractedInvoice.patchValue({ terms_agreed: false });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.extractedInvoice.get("terms_agreed").value === false) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  onDrop(event: any) {
    // Update the list order
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
  }

  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > 100 * 1024 * 1024) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.extractedInvoice.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;

        this.loading = true;
        this.invoiceChanged = true;
        this.formSubmitted = true;

        // Create ledger array similar to e-invoice submission
        const ledger: any[] = [
          {
            docType: this.invoiceDetails.docType || "",
            docDetail: {
              docFormat: "e-invoice",
              docCat: "po_based", // or determine based on context
            },
            cmpCode: this.invoiceDetails.cmpCode || "",
            purchaseOrg: this.invoiceDetails.purchaseOrg || "",
            erpDocType: this.invoiceDetails.erpDocType || "",
          },
        ];

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("sellerCode"));
        formData.append("supplierCode", localStorage.getItem("vendorCode"));
        formData.append("ledger", JSON.stringify(ledger));
        formData.append("invoiceFile", this.extractedInvoice.value.fileSource);
        formData.append("extractionVersion", "1");

        this.eLoaderMsg = "Verifying QR Code";

        setTimeout(() => {
          this.eLoaderMsg = "Authenticating QR Code";
        }, 5000);
        setTimeout(() => {
          this.eLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.eLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.extractInvoice(formData).subscribe(
          (res) => {
            this.loading = false;
            this.invoiceChanged = false;
            this.formSubmitted = false;
            this.isUpdatedData = true;
            this.responseData = res;
            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              console.error(this.responseData.message);
            } else {
              this.invoiceDetails = this.responseData;
            }
          },
          (error) => {
            console.error(error);
          }
        );
      }
    }
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  onSubmit() {
    this.loading = true;
    this.uploadInvoice = true;
    this.saving = false;
    this.formSubmitted = true;
    this.hasError = false;

    const pods: any = localStorage.getItem("pods");
    const convertPods = JSON.parse(pods);

    const poItems: any = [];
    convertPods.forEach((p: any) => {
      if (p.docNo !== "" || typeof p.docNo !== "undefined") {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: p._id,
        });
      } else {
        poItems.push({
          poNo: p.poNo,
          itemNo: p.poLineNo,
          grn: "",
        });
      }
    });


    let companyCode = "";
    let purchaseOrg = "";
    let docType = "";

    if (convertPods[0].docNo !== "") {
      companyCode = convertPods[0].cmpCode;
      purchaseOrg = convertPods[0].purchaseOrg;
      docType = convertPods[0].erpDocType;
    } else {
      companyCode = localStorage.getItem("servCompanyCode");
      purchaseOrg = localStorage.getItem("servPurchaseOrg");
      docType = localStorage.getItem("servDocType");
    }

    const userData = {
      req: {
        emailAddress: this.invoiceDetails.email_address,
        companyCode: companyCode,
        purchaseOrg: purchaseOrg,
        docType: docType,
        items: poItems,
        termsAgreed: true,
      },
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.extractedInvoice.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });

    const currentUser = this.authService.getCurrentUser();

    const led = this.invoiceService.getProcessedInvoice();
    const timestamp = Date.now();

    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(led.invoice_date),
        dueDate: this.dateUtils.formatDateString(led.invoice_date),
        dueAmt: led.invoice_amount,
        docAmt: led.invoice_amount,
        docType: "APINV",
        poNo: led.poNo,
        docNo: led.invoice_number,
        timestamp: timestamp,
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.invoiceDetails.invoice_amount,
          docFormat: this.invoiceDetails.docFormat,
          docCat: "po_based",
          docGstin: this.invoiceDetails.gstin,
          irn: this.invoiceDetails.irn,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link,
          },
        ],
        lineItemDetail: [
          {
            poLineNo: convertPods[0].poLineNo,
            grn: convertPods[0]._id, // GRN number logic requires this string concatentation
            grnNo: convertPods[0].docNo,
          },
        ],
        supplierCode: localStorage.getItem("vendorCode"),
        cmpCode: userData.req.companyCode,
        purchaseOrg: userData.req.purchaseOrg,
        erpDocType: userData.req.docType,
      },
    ];

    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify(currentUser.eippSessionData.data.session));
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    // for (const value of formData.values()) {
    // }

    if (!this.saving) {
      this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
        (res) => {
          this.responseData = res;
          if (this.responseData.status === "error") {
            this.loading = false;
            this.uploadInvoice = false;
            this.hasError = true;
            this.formSubmitted = false;
          } else {
            this.barcodeNo = this.responseData.barcode;
            this.uploadSuccessful = true;
            this.uploadInvoice = false;
          }
        },
        (error) => {
          this.loading = false;
          this.error = error.error.message;
          this.uploadInvoice = false;
          this.uploadSuccessful = false;
          this.invoiceSaved = false;
          this.serverError = true;
        }
      );
    }

    this.modalService.dismissAll();
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getProcessedInvoice();
    localStorage.setItem("poNo", this.invoiceDetails.poNo);
    localStorage.setItem("docRef", this.invoiceDetails.file_link);
    this.loadFile();
    this.formSubmitted = false;

    const poNo = this.route.snapshot.params["poNo"];
    this.poNo = poNo;
    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      filters: [
        {
          key: "docType",
          value: "POD",
        },
        {
          key: "poNoNumberOrString",
          value: poNo,
        },
      ],
      pageSize: 10,
      pageNo: 1,
      sellercode: this.authService.getSellerCode(),
      isExport: false,
      linkFilters: [],
      isAP: true,
      isPOD: true,
    };

    this.posService.fetchPurchaseOrders(userData).subscribe(
      (res) => {
        this.responseData = res;
        if (this.responseData.length !== 0) {
          this.servItems = this.responseData.data.list[0];
        } else {
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/invoices");
  }

  closeErrorDialog() {
    this.loading = false;
    this.savingError = false;
    this.serverError = false;
  }

  resubmitInvoice() {
    const poNo = this.route.snapshot.params["poNo"];
    this.router.navigate(["/submit-invoice", poNo]);
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }
  }

  viewSavedInvoices() {
    this.router.navigate(["/saved-invoices"]);
  }
}
